import { type Enum } from '@webapp/infrastructure/types/Enum'

// Expense Status Page
export const ExpenseStatusPageTabStatuses = {
  ALL: 'all',
  PENDING: 'pending',
  DENIED: 'denied',
  APPROVED: 'approved',
} as const

export type ExpenseStatusPageTabStatus = Enum<
  typeof ExpenseStatusPageTabStatuses
>

export interface ExpenseStatusPageParams {
  status: ExpenseStatusPageTabStatus
}

export interface ExpenseDetailsPageParams {
  uuid: uuid
}

// Expense Approvals Page
export const ExpenseApprovalsPageTabStatuses = {
  ALL: 'all',
  PENDING: 'pending',
  APPROVED: 'approved',
  DENIED: 'denied',
} as const

export type ExpenseApprovalsPageTabStatus = Enum<
  typeof ExpenseApprovalsPageTabStatuses
>

export interface ExpenseApprovalsPageParams {
  status: ExpenseApprovalsPageTabStatus
}
